import { createBrowserRouter, RouteObject } from 'react-router-dom';

import { isFeatureEnabled } from 'ff/common/ffAppUtils';

import HomeRoute from 'ff/debrief/router/routes/HomeRoute';
import DebriefRoute from 'ff/debrief/router/routes/DebriefRoute';
import SharedRoute from 'ff/debrief/router/routes/SharedRoute';

const routes: RouteObject[] = [HomeRoute, SharedRoute];
if (isFeatureEnabled('debrief_features')) routes.push(DebriefRoute);

export const router = createBrowserRouter(routes, { basename: '/debrief' });
